import { ListarEstadoPorIdService, ListarEstadosService } from "../../../../Services/Geral/Endereco/Estado/EstadoServices";
import { Controller } from "../../../Controller";

export async function ListarEstadosController() {
    return Controller(ListarEstadosService());
}

export async function ListarEstadoPorIdController(idEstado: number) {
    return Controller(ListarEstadoPorIdService(idEstado));
}
